export default __webpack_public_path__ + "static/media/close.84cc8ac1.png";